export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8277.8cf556c7.jpg";